export default "__VITE_ASSET__MUV3v4ngPguySGDMUo_y$w__"